export const METADATA_VERSION_KEY = Symbol('metadataVersion');
//# sourceMappingURL=constants.js.map